<template>
	<div>
		<mainDiv :info="block" />
	</div>
</template>

<script>
	import mainDiv from '@/components/skill/main'

	export default {
		props:{
			block:{
				required:false,
				type:Object
			}
		},
		components: {
			mainDiv,
		},
		created(){
			this.$emit('headerCur',1);
		}
	}
</script>

<style>
</style>
